export default __webpack_public_path__ + "static/media/Flag_of_Syria.38189413.svg";